import { render, staticRenderFns } from "./roleConfig.vue?vue&type=template&id=bac507ce&"
import script from "./roleConfig.vue?vue&type=script&lang=js&"
export * from "./roleConfig.vue?vue&type=script&lang=js&"
import style0 from "./roleConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports